<svg fill="none" height="24" viewBox="0 0 21 24" width="21" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M11.742 6.25708H8.82773V8.74279H6.42773V11.5714H8.82773V14.0571H11.742V11.5714H14.142V8.74279H11.742V6.25708Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M10.2853 23.9999C11.7424 23.9999 12.8567 22.8856 12.8567 21.5142H7.71387C7.71387 22.8856 8.82815 23.9999 10.2853 23.9999Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M18 16.6286V10.4571C18 6.68571 15.8571 3.51429 12.1714 2.65714V1.8C12.2571 0.857143 11.3143 0 10.2857 0C9.25714 0 8.4 0.857143 
    8.4 1.88571V2.74286C4.62857 3.51429 2.57143 6.68571 2.57143 10.4571V16.6286L0 19.1143V20.3143H20.5714V19.1143L18 16.6286ZM10.2857 
    16.1143C6.94286 16.1143 4.28571 13.4571 4.28571 10.1143C4.28571 6.77143 6.94286 4.11429 10.2857 4.11429C13.6286 4.11429 16.2857 
    6.77143 16.2857 10.1143C16.2857 13.4571 13.6286 16.1143 10.2857 16.1143Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
